export interface LeadClassification {
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    utm_content: string;
    utm_term: string;
}
export const leadClassification = (landingUrl?: string, discoveryUrl?: string, sourceUrl?: string): LeadClassification => {
    if (!landingUrl || !discoveryUrl) {
        return {
            utm_source: "",
            utm_medium: "",
            utm_campaign: "",
            utm_content: "",
            utm_term: "",
        };
    }

    function extractDomain(url?: string): string | null {
        if (!url) return null;
        const regex = /https:\/\/(?:www\.)?([^/]+?)(?:\.com)?(?=\/|$)/;
        const match = url.match(regex);
        return match ? match[1].split(".").slice(0, 2).join(".") : null;
    }

    const organicBrandPaths = ["/", "/pricing", "/login", "/whatsapp", "/about", "/contact"];

    const sources = [/google/, /bing/, /yahoo/, /duckduckgo/];

    const extractParams = (url?: string): URLSearchParams | null => {
        const paramsString = url?.split("?")[1];
        if (!paramsString) {
            return null;
        }
        return new URLSearchParams(paramsString);
    };

    const landingParams = extractParams(landingUrl);
    const discoveryParams = extractParams(discoveryUrl);

    function getParam(paramName: string): string {
        return landingParams?.get(paramName) || discoveryParams?.get(paramName) || "";
    }

    const hasParam = (paramName: string): boolean => {
        return !!(landingParams?.has(paramName) || discoveryParams?.has(paramName));
    };

    const isorganicBrand = (path: string): boolean => {
        return organicBrandPaths.some((excluded) => path === excluded);
    };

    let utmSource = "";
    let utmMedium = "";
    let utmCampaign = "";
    let utmContent = "";
    let utmTerm = "";

    if (landingParams || discoveryParams) {
        utmSource = getParam("utm_source");
        utmMedium = getParam("utm_medium");
        utmCampaign = getParam("utm_campaign");
        utmContent = getParam("utm_content");
        utmTerm = getParam("utm_term");

        const source = utmSource.toLowerCase();

        if (source === "google" || hasParam("gclid")) {
            utmSource = "google";
            utmMedium = "ads";
        } else if (source === "meta" || hasParam("fbclid")) {
            utmSource = "meta";
            utmMedium = "ads";
        } else if (source === "bing" || hasParam("msclid")) {
            utmSource = "bing";
            utmMedium = "ads";
        } else if (source === "organic" || hasParam("error") || (!source && !sourceUrl)) {
            utmSource = "direct";
        } else {
            utmSource = "referral";
            utmMedium = utmSource || getParam("ref") || extractDomain(sourceUrl) || getParam("utm_medium") || "";
        }
    } else if (sourceUrl && sources.some((pattern) => pattern.test(sourceUrl)) && !isorganicBrand(landingUrl as string)) {
        utmSource = sources.find((pattern) => pattern.test(sourceUrl))?.source ?? "";
        utmMedium = "SEO";
    } else if (sourceUrl && sources.some((pattern) => pattern.test(sourceUrl))) {
        utmSource = sources.find((pattern) => pattern.test(sourceUrl))?.source ?? "";
        utmMedium = "organic brand";
    } else if (sourceUrl) {
        utmMedium = extractDomain(sourceUrl) ?? "";
        utmSource = "referral";
    } else if (!sourceUrl) {
        utmSource = "direct";
    }

    return {
        utm_source: utmSource,
        utm_medium: utmMedium,
        utm_campaign: utmCampaign,
        utm_content: utmContent,
        utm_term: utmTerm,
    };
};
